import React from "react";
import { Image, Container, Row, Col } from "react-bootstrap";
import "./lobby.css";

import BackImg from "../../assets/img/lobby_back.png";
import FrontImg from "../../assets/img/lobby_front.png";
import Screen1Img from "../../assets/img/screen1.png";
import Screen2Img from "../../assets/img/screen2.png";
import AppsImg from "../../assets/img/apps.svg";

//Components
import DownloadSection from "../../components/Download-section/download-section";
import Feedbacks from "../../components/Feedbacks/feedbacks";
import Footer from "../../components/Footer/Footer";

const Lobby = () => {
  return (
    <React.Fragment>
      <div className="lobby-wrapper">
        <section id="lobby">
          <Container fluid>
            <Container className="pt-5">
              <div className="lobby-image">
                <img src={FrontImg} />
              </div>
              <h2 className="display-4 brand-font" data-aos="zoom-in">
                Managers’ Lobby{" "}
              </h2>
              <div className="lobby-text">
                <p
                  className="lobby-p"
                  style={{ maxWidth: "572px" }}
                  data-aos="fade-right"
                >
                  The first screen of its kind, enabling full and accurate
                  control of project budgets.
                  <br />
                  Control of progressive figures – expenses, revenues and
                  delivery destinations. Customized screen based on company
                  needs.
                </p>
              </div>
              <div className="screen1-image">
                <img src={Screen1Img} />
              </div>
              <h2 className="display-4 mt-4 pt-3 brand-font" data-aos="zoom-in">
                Project Management System{" "}
              </h2>
              <div className="lobby-text">
                <p
                  className="lobby-p"
                  style={{ maxWidth: "572px" }}
                  data-aos="fade-right"
                >
                  A dedicated system for business customers – a monthly
                  subscription – progressive managers’ dashboard. <br />
                  Credit management and budget distribution management, <br />
                  dedicated customer service Project history and personal
                  details{" "}
                </p>
              </div>
              <div className="screen2-image mt-4">
                <img src={Screen2Img} />
              </div>
              <div className="lobby-bottom mb-4 mt-1">
                <div className="lobby-ul pt-5">
                  <h2
                    className="display-4 mt-2 pt-3 brand-font"
                    data-aos="zoom-in"
                  >
                    System Advantages{" "}
                  </h2>
                  <ul data-aos="fade-right">
                    <li> Real time project monitoring and control</li>
                    <li>
                      E-mail quantities, bills of lading and receipts for all
                    </li>
                    <li>
                      transactions Consolidated invoice for each project, two
                      hours from order to delivery Obligo transfer from one
                      project to another
                    </li>
                    <li> And more</li>
                  </ul>
                </div>
              </div>
            </Container>
          </Container>
        </section>
      </div>
      <DownloadSection />
      <Feedbacks />
      <Footer />
    </React.Fragment>
  );
};

export default Lobby;
